import { useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "../lib/api";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/Marquee";
import { WhatWeDo } from "../components/WhatWeDo";
import { Services } from "../components/Services";
import { Projects } from "../components/Projects";
import { WhyUs } from "../components/WhyUs";
import { About } from "../components/About";
import { Reviews } from "../components/Reviews";
import { Socials } from "../components/Socials";
import { CtaBanner } from "../components/CtaBanner";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { MobileCta } from "../components/MobileCta";

export default function Landing() {
  const [services, setServices] = useState([]);
  const [projects, setProjects] = useState([]);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, wheelMultiplier: 1.05 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  return (
    <div className="grain bg-[#050505] text-white" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <WhatWeDo />
        <Services services={services} />
        <Projects projects={projects} />
        <CtaBanner />
        <WhyUs />
        <About />
        <Reviews reviews={reviews} />
        <Socials />
        <Contact services={services} />
      </main>
      <Footer services={services} />
      <MobileCta />
    </div>
  );
}
